<template>
    <div class="rc-table-run" ref="rcTableRun" @mouseleave="tableMouseLeave">
      <div class="rc-table-header">
        <label class="item-name">{{component.name}}</label>
        <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
          <span class="fa fa-question-circle"></span>
        </el-tooltip>
        <span class="rc-table-runtime-tip" v-if="!(component.properties.disableCopy && component.properties.disablePaste)"><i class="el-icon-warning"></i></span>
      </div>
        <el-table
          :data="rows" row-key="id" :ref="component.id" :max-height="36+42*component.properties.maxNum+'px'" :height="height"
          :class="['tableClass', component.children && component.children.length > component.properties.maxNum && 'update-left', disable && 'el-disable', isFirefox && 'firefox-scrollbar']"
          @row-click="clickRow" :row-class-name="tableRowIndex" cell-class-name="cell-padding"
          @row-dblclick="dblclickRow" border :highlight-current-row="true">
          <el-table-column
            type="index" align="center" class-name="rc-table-index">
          </el-table-column>
          <el-table-column v-if="component.properties.checkLine"
            align="center" width="48" class-name="rc-table-check">
            <template slot="header" slot-scope="scope">
              <el-checkbox :indeterminate="checkLine.isIndeterminate" v-model="checkLine.checkAll" @change="handleCheckAllChange"></el-checkbox>
            </template>
            <template slot-scope="scope">
              <el-checkbox :value="getSelect(scope.row)" @change="updateCheck($event, scope.row)"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :width="columnWidth(item)"
                           v-for="(item, index) in componentChildren"
                           :key="item.id"
                           :index="index"
                           :label="item.name"
                           :label-class-name="getRequired(item)?'requrired':'' "
                           header-align="center"
                           :class-name="getCellClassName(item)">
            <template slot="header" slot-scope="scope">
              <el-tooltip :content="item.name" placement="top-start" :disabled="!item.name || columnWidth(item) >= getTextWidth(item.name, 14)">
                <span :class="{'rc-table-run-label-overflow':(!item.name || columnWidth(item) < getTextWidth(item.name, 14)),'rc-table-run-label':(!item.name || columnWidth(item) >= getTextWidth(item.name, 14))}">{{item.name}}</span>
              </el-tooltip>
              <el-tooltip class="component-explain-tooltip" :style="getTooltipStyle(item)" v-if="item.properties.componentExplain" :content="item.properties.componentExplain" placement="bottom-start">
                <span class="fa fa-question-circle"></span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div v-if="getItem(item, scope.row.id)" :class="[getComponentClass(item, scope.$index)]" @mousedown="tableMouse('down')" @mouseup="tableMouse('up')" @dragstart.stop="domDragstart" @dblclick="dbClick(scope)">
                <component
                  :class="getActiveControl(item, scope.$index)"
                  ref="children"
                  type="index"
                  :is="item.componentType"
                  :component="getItem(item, scope.row.id)"
                  :index="getIndex(scope.$index)"
                  :value="getChildrenData(item, getIndex(scope.$index))"
                  :parentPath="getChildrenPath(getIndex(scope.$index))"
                  :disabled="readonly || !isReadonly(scope.$index)||component.properties.enableEdit ? true : disabled"
                  :labelParameter="labelParameter"
                  :startSelect="copyPaste.moveState"
                  :isTable="!component.properties.enableEdit"
                  :isDisableCopy="component.properties.disableCopy"
                  :tableCtrlKey="tableCtrlKey"
                  :tableRelationId="component.archive.relationId"
                  @saveDataSource="updateDataSource"
                  @input="(value) => updateChildValue(item.archive.columnId, value, getIndex(scope.$index))"
                  @initRelated="(component, callback) => callbackRelated(component, {'callback': callback, 'index': getIndex(scope.$index)})"
                  @initDefaultValue="(component, callback) =>callbackDefault(component, {'callback': callback, 'index': getIndex(scope.$index)})"
                  @calculation="(expression) => calculation(expression, getIndex(scope.$index))"
                  @previewOrUploadFile="previewOrUploadFile"
                  @controlClick="controlClick"
                  @controlMove="controlMove">
                </component>
                <span class="resize-icon" @mousedown.stop="tableMouse('down', true)" @mouseup.stop="tableMouse('up', true)"></span>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="!disable" class-name="operation-class" label=" " width="50px" align="center" :fixed="isFixed">
            <template slot-scope="scope">
              <template v-if="isReadonly(scope.$index)">
                 <span class="icon-container" v-if="component.properties.enableEdit">
                   <span class="el-icon-edit icon-item" @click.stop.prevent="editRow(scope)"></span>
                 </span>
                <span class="icon-container" v-if="!component.properties.lockRow && !readonly">
                  <span class="el-icon-circle-close" @click.stop.prevent="delRow(scope)"></span>
                </span>
              </template>
            </template>
          </el-table-column>
        </el-table>
      <div v-if="!disable && !readonly" class="rc-table-footer">
        <div class="rc-add-button" @click="addRow(true)" v-if="!component.properties.lockRow">
          <i class="el-icon-plus"></i> <span class="add-button">添加</span>
        </div>
      </div>
      <!-- 隐藏列使用另一个表格单独处理 -->
      <el-table :data="rows" row-key="id" style="display: none">
        <el-table-column v-for="item in hiddenColumns" :key="item.id" :label="item.name">
          <template slot-scope="scope">
            <component
              ref="children"
              type="index"
              :is="item.componentType"
              :component="item"
              :index="getIndex(scope.$index)"
              :value="getChildrenData(item, getIndex(scope.$index))"
              :parentPath="getChildrenPath(getIndex(scope.$index))"
              :disabled="!isReadonly(scope.$index)||component.properties.enableEdit ? true : disabled"
              :labelParameter="labelParameter"
              :isTable="!component.properties.enableEdit"
              :isDisableCopy="component.properties.disableCopy"
              :tableCtrlKey="tableCtrlKey"
              @saveDataSource="updateDataSource"
              @input="(value) => updateChildValue(item.archive.columnId, value, getIndex(scope.$index))"
              @initRelated="(component, callback) => callbackRelated(component, {'callback': callback, 'index': getIndex(scope.$index)})"
              @initDefaultValue="(component, callback) =>callbackDefault(component, {'callback': callback, 'index': getIndex(scope.$index)})"
              @calculation="(expression) => calculation(expression, getIndex(scope.$index))">
            </component>
          </template>
        </el-table-column>
      </el-table>
      <div class="edit-dialog">
        <el-dialog v-if="dialogVisible" class="rc-table-edit-dialog" :title="title" :visible.sync="dialogVisible" width="824px" center append-to-body :close-on-click-modal="false" :close-on-press-escape="false">
          <div class="item" v-if="!item.properties.hidden" v-for="(item, index) in component.children" :key="item.id + index">
            <div class="left" :title="item.name">{{ item.name }}</div>
            <div class="right">
              <component
                v-if="!item.properties.hidden"
                ref="dialogChildren"
                type="index"
                :is="item.componentType"
                :component="item"
                :index="getIndex(selectScope.$index)"
                :value="getChildrenData(item, getIndex(selectScope.$index))"
                :parentPath="getChildrenPath(getIndex(selectScope.$index))"
                :disabled="!isReadonly(selectScope.$index) || disabled || readonly"
                :labelParameter="labelParameter"
                :isTable="!component.properties.enableEdit"
                :isDisableCopy="component.properties.disableCopy"
                @saveDataSource="updateDataSource"
                @input="(value) => updateChildValue(item.archive.columnId, value, getIndex(selectScope.$index))"
                @initRelated="(component, callback) => callbackRelated(component, {'callback': callback, 'index': getIndex(selectScope.$index)})"
                @initDefaultValue="(component, callback) =>callbackDefault(component, {'callback': callback, 'index': getIndex(selectScope.$index)})"
                @calculation="(expression) => calculation(expression, getIndex(selectScope.$index))">
            </component>
          </div>
          </div>
          <span slot="footer" class="dialog-footer">
          <el-button @click="save">保存</el-button>
          <el-button @click="cancelSave(true)">取消</el-button>
        </span>
        </el-dialog>
      </div>
    </div>
</template>

<script>
import { containerInitMixin, componentMixin, calculationMixin, relFunMixin, containerMixin, defaultValueMixin } from './mixins'
import RcInput from './rc-input.vue'
import RcNumeric from './rc-numeric.vue'
import RcPhone from './rc-phone.vue'
import RcUuid from './rc-uuid.vue'
import RcDate from './rc-date.vue'
import RcCurrency from './rc-currency.vue'
import RcPassword from './rc-password.vue'
import RcCombobox from './rc-combobox.vue'
import RcCoding from './rc-coding.vue'
import RcFlowingWater from './rc-flowing-water.vue'
import RcFile from './rc-file.vue'
import RcLoginUser from './rc-login-user.vue'
import RcIdCard from './rc-id-card.vue'
import RcChildrenInput from './rc-children-input.vue'
import RcDataSource from './rc-data-source.vue'
import RcButton from './rc-button.vue'
import RcSwitch from './rc-switch.vue'
import RcCascader from './rc-cascader.vue'
import RcBigFileUpload from './rc-big-file-upload.vue'
import RcRate from './rc-rate.vue'
import RcTextarea from './rc-textarea.vue'

import _ from 'lodash'
export default {
  name: 'rc-table',
  // mixins 的引入顺序不能乱改, 因为有同名的init方法, 表格的componentMixin必须在containerInitMixin后面, 表格使用控件的init
  mixins: [ containerInitMixin, componentMixin, calculationMixin, relFunMixin, containerMixin, defaultValueMixin ],
  props: ['component', 'position', 'value', 'disabled', 'labelParameter'],
  inject: {
    eventBus: 'eventBus',
    formArgs: 'formArgs',
    parentFormId: 'id',
    _redcatEventBus: {
      default: null
    }
  },
  data () {
    return {
      disable: this.disabled,
      selectedTr: [],
      tableData: [{
        name: ''
      }],
      enableEvent: false,
      isFixed: null,
      isFirefox: false, // 火狐浏览器单独处理
      dialogVisible: false,
      title: '编辑',
      selectScope: {},
      // 因为下拉框会手动请空一次，所以需要保存前两次的值
      comboboxValue: [],
      editDialogFormRuntimeWidth: '',
      tableEdit: {
        switch: true,
        data: {}
      },
      columns: [],
      columnsProperties: {},
      requiredList: [],
      copyPaste: {
        activeComponent: {},
        selectControlIds: [],
        moveState: false,
        canMove: false,
        firstSelectControl: {},
        controlIds: [],
        rightSelectControl: {}
      },
      tableCtrlKey: false,
      defaultTableData: [],
      initLength: 0,
      checkLine: {
        selectRows: [],
        checkAll: false,
        isIndeterminate: false
      }
    }
  },
  components: {
    RcInput,
    RcNumeric,
    RcPhone,
    RcUuid,
    RcDate,
    RcCurrency,
    RcPassword,
    RcCombobox,
    RcCoding,
    RcFlowingWater,
    RcFile,
    RcLoginUser,
    RcChildrenInput,
    RcIdCard,
    RcDataSource,
    RcButton,
    RcSwitch,
    RcCascader,
    FormRuntime: () => import('../form-runtime.vue'),
    RcBigFileUpload,
    RcRate,
    RcTextarea
  },
  methods: {
    initComponent (type) {
      this.enableEvent = true
      // 默认生成行数，为表格的属性，写在表格自己的初始化方法里面
      if (this.component.properties.numberOfLines && this.rows) {
        let needRender = false
        // 非分组内的重新渲染才需要执行重新渲染行数
        if (this.initState.type === 'process' && type !== 'rcTableReRender') {
          // 如果是流程的话只有在当前节点需要初始化默认行数,返回修改也不需要初始化
          if ((!this.initState.historyNodeIds.includes(this.initState.currentNodeId)) &&
          (!this.initState.connections.filter(it => it.targetNodeId === this.initState.currentNodeId && it.operationType === 'back').map(it => it.sourceNodeId).some(it => this.initState.historyNodeIds.includes(it)))) {
            needRender = true
          }
        } else {
          // 表单只有新建的时候才需要初始化默认行数
          needRender = this.dataService.data.dataState === 'create'
        }
        if (needRender) {
          let time = this.component.properties.numberOfLines - this.rows.length
          let unWatch = this.$watch(() => {
            return {
              initLength: this.initLength,
              data: this.defaultTableData
            }
          }, async val => {
            if (val.initLength === 0 && (val.data.length || Object.keys(this.component.properties.tableDataSource.filter).length)) {
              // 辅助表有几条数据，表格就加载多少条。
              if (this.value.length < val.data.length && !Object.keys(this.component.properties.tableDataSource.filter).length) {
                let needAddRow = val.data.length - this.value.length
                this.initLength = needAddRow
                for (let i = 0; i < needAddRow; i++) {
                  this.addRow()
                }
              } else {
                const clear = () => {
                  let dataBinding = this.component.properties.tableDataSource.dataBinding
                  dataBinding && dataBinding.length && dataBinding.forEach(d => {
                    // componentId：控件
                    // showColumnId：字段
                    if (d.componentId && d.showColumnId) {
                      for (let i = 0; i < this.value.length; i++) {
                        this.$set(this.value[i], d.componentId, null)
                      }
                    }
                  })
                }
                await clear()
                if (this.defaultTableData.length !== 0) {
                  for (let i = 0; i < val.data.length; i++) {
                    this.setValueWithDataSource(i)
                  }
                  unWatch()
                }
              }
            }
            // 为了防止辅助表没有数据的情况，需要销毁当前监听
            setTimeout(() => unWatch && typeof unWatch === 'function' && unWatch(), 5000)
          })
          this.initLength = time
          for (let i = 0; i < time; i++) {
            this.addRow()
          }
        }
      }
      // 视图组件渲染完再去执行子控件的初始化
      this.$nextTick(() => {
        Promise.all([(this.$refs.children || []).map(m => m.init())])
      })
    },
    // 当前行的颜色
    tableRowIndex ({row, rowIndex}) {
      row.index = rowIndex
      if (this.selectedTr.includes(row.index)) {
        return 'selected'
      }
    },
    async addRow (initState = false) {
      if (Object.keys(this.tableEdit.data).length) {
        this.$set(this.tableEdit, 'data', {})
      }
      if (!this.dataService.schema.tables) {
        let watch = this.$watch('dataService.schema.tables', (newValue, oldValue) => {
          if (this.dataService.schema.tables) {
            this.addRowEvent(this.component.properties.enableEdit, initState)
            watch()
          }
        })
      } else {
        if (initState) {
          await this.beforeAddTable().then(() => this.addRowEvent(this.component.properties.enableEdit, initState))
        } else {
          this.addRowEvent(this.component.properties.enableEdit, initState)
        }
      }
    },
    // state: 开启了编辑的添加和普通添加不一样
    addRowEvent (state = false, initState) {
      let table = this.dataService.schema.tables.find(t => t.tableId === this.component.archive.tableId)
      let data = this.dataService.buildData(table)
      state && initState && (data.isSave = 0)
      if (initState) {
        this.checkLine.isIndeterminate = this.checkLine.selectRows.length !== this.rows.length
        this.checkLine.checkAll = this.checkLine.selectRows.length === this.rows.length
      }
      this.value.push(data)
      this.$nextTick(() => {
        if (initState) {
          for (let i = 1; i <= this.component.children.length; i++) {
            let childrenComponent = this.$refs.children[this.$refs.children.length - i]
            childrenComponent && childrenComponent.init()
          }
        }
        this.$nextTick(() => {
          this.initLength !== 0 && this.initLength--
          state && initState && this.editRow({$index: this.value.length - 1}, '添加')
          this.scrollDown()
        })
      })
    },
    scrollDown () {
      this.$nextTick(() => {
        let scroll = this.$refs.rcTableRun.querySelector('.tableClass').querySelector('.el-table__body-wrapper')
        if (scroll.scrollHeight > scroll.clientHeight) {
          scroll.scrollTop = scroll.scrollHeight - scroll.clientHeight
        }
      })
    },
    // 删除
    delRow (scope) {
      const index = this.getIndex(scope.$index)
      const row = this.value[index]
      this.$refs.children && this.$refs.children.filter(c => c.index === index).forEach(c => c && c.component.componentType === 'rc-file' && c.beforeDelete())
      this.$nextTick(() => {
        if (this.selectedTr.includes(index)) {
          this.selectedTr.pop()
        }
        if (row.dataState === 'update') {
          row.dataState = 'delete'
        } else {
          this.value.splice(index, 1)
        }
        this.eventBus.$emit('form.table-row-delete', {scope: scope, component: this.component})
      })
      // 因为选中是根据索引选中的，所以删除行之后，需要清空选中的数据
      this.cancelSelect()
    },
    // 编辑
    async editRow (scope, title = '编辑') {
      this.selectScope = _.cloneDeep({row: scope.row, $index: scope.$index})
      // 判断引用的表单是否为本表单
      if (this.component && this.component.properties && this.component.properties.selectForm !== '[默认表单]' && this._redcatEventBus) {
        // 未请求过表单编辑引用表单宽度属性的时候请求一次，不重复请求
        if (!this.editDialogFormRuntimeWidth) {
          let selectProperties = await this.getFormWidth(this.component.properties.selectForm) || JSON.stringify({formScreen: 'full'})
          this.editDialogFormRuntimeWidth = JSON.parse(selectProperties.properties).formScreen
        }
        this.tableEdit.data = {...scope.row}
        let params = {
          id: this.component.properties.selectForm,
          data: this.tableEdit.data,
          width: this.editDialogFormRuntimeWidth,
          title,
          disabled: this.readonly || this.disabled
        }
        let currentTableFormListener = this._redcatEventBus.formRuntimeListenerArray.find(item => item.id === this.parentFormId)
        currentTableFormListener.redcatEventBus.$emit('rcTable.editViaForm', {params, id: this.component.id})
      } else {
        // [默认表单]使用固定弹窗打开
        this.dialogVisible = true
        this.title = title
        this.$nextTick(() => {
          return Promise.all([(this.$refs.dialogChildren || []).map(m => m.init())])
        })
      }
    },
    // 单击选中这一行
    clickRow (row, event, column) {
      if (!this.enableEvent) {
        return
      }
      let rowIndex = row.index
      if (!this.selectedTr.some(m => m === rowIndex)) {
        this.selectedTr.pop()
        this.selectedTr.push(rowIndex)
      }
      this.eventBus.$emit('form.table-row-click', {row, component: this.component})
    },
    // 双击不选中
    dblclickRow (row, event) {
      if (!this.enableEvent) {
        return
      }
      let rowIndex = row.index
      this.selectedTr.forEach((item, index) => {
        if (item === rowIndex) {
          this.selectedTr.splice(index, 1)
        }
      })
    },
    getIndex (index) {
      // 点击了添加按钮，但是还未保存
      return this.value.length > this.rows.filter(m => m.isSave !== 0) ? this.value.length - 1 : this.value.indexOf(this.rows[index])
    },
    compareWidth () {
      let allWidth = 0
      this.component.children && this.component.children.forEach(component => {
        allWidth += this.columnWidth(component)
      })
      return allWidth > this.$refs[this.component.id].$el.clientWidth
    },
    save () {
      if (this.value.length > this.rows.filter(m => m.isSave !== 0).length) {
        delete this.value[this.selectScope.$index].isSave
      }
      this.$nextTick(() => this.cancelSave())
    },
    cancelSave (canOverwrite = false) {
      // 这里逻辑不对，按这里原来的想法应该是删掉所有被标记为'delete'状态的，但是pop肯定不对。同时后端也对该状态的数据做了删除，所以前端这段逻辑可以不要
      // if (this.value.length > this.rows.filter(m => m.isSave !== 0).length) {
      //   this.value.pop()
      // }
      this.dialogVisible = false
      // TODO: 表格编辑级联有问题暂时没有修复
      if (canOverwrite && this.component && this.component.properties && this.component.properties.selectForm === '[默认表单]') {
        // 不存在当前选中行的数据时说明是 添加,取消的时候删除最后一行
        if (!this.selectScope.row) {
          this.value.pop()
        } else {
          for (let key in this.selectScope.row) {
            if (key !== 'id' && key !== 'index' && key !== 'dataState') {
              if (this.value[this.selectScope.$index] && this.value[this.selectScope.$index].hasOwnProperty(key)) {
                this.$set(this.value[this.selectScope.$index], key, this.selectScope.row[key])
              }
            }
          }
        }
      }
      this.$set(this.tableEdit, 'data', {})
    },
    recursionDataState (variables) {
      for (let key in variables) {
        if (variables[key] instanceof Array) {
          variables[key].forEach(el => {
            el.dataState = this.value[0].dataState
            this.recursionDataState(el)
          })
        }
      }
    },
    // 获取表单数据，对比然后修改
    getFormData (data) {
      // 表格的数据删除是软删，只是更新了数据状态为delete，这里不能根据之前存的索引去更新值，这里要找到数据的真正索引位置
      let dataIndex = this.value.findIndex(item => item.id === data.id)
      if (dataIndex === -1) {
        dataIndex = this.selectScope.$index
      }
      // 保证id和dataState不会被覆盖
      delete data.id
      delete data.dataState
      let value
      if (this.selectScope.row) {
        value = {...this.selectScope.row}
      } else {
        value = {...this.value[dataIndex]}
      }
      value = _.merge(value, data)
      this.$set(this.value, dataIndex, value)
      if (this.value.length > this.rows.filter(m => m.isSave !== 0).length) {
        delete this.value[dataIndex].isSave
      }
    },
    // 获取列的归档id
    getColumns () {
      return this.component.children ? this.component.children.map(c => c.archive && c.archive.columnId) : []
    },
    async getFormWidth (id) {
      if (id === '[默认表单]') {
        return '[默认表单]'
      }
      let selectProperties
      await this.$axios.get(`${this.$route.name === 'formRuntimeOutsideChain' ? '/form-api/publicPublish/runtime/findFormByArchivedId' : '/form-api/defines/findFormByArchivedId'}/${this.component.archive.tableId}`).then(res => {
        selectProperties = res.data.filter(f => f.id === id)
      })
      return selectProperties[0]
    },
    validateRcFile () {
      // 调用 文件上传的校验，因为rc-file没有文本框了，所以需要手动加校验状态
      this.$refs.children && this.$refs.children.forEach(c => c && c.component.componentType === 'rc-file' && c.customValidate())
      this.formData = {}
    },
    async beforeAddTable () {
      return this.eventBus.$emit('beforeAddTableRow', {component: this.component})
    },
    isReadonly (index) {
      if (this.component.properties.readonly) {
        //  只有表格只读需要判断
        let length = this.value.filter(n => n.dataState === 'update').length - 1
        return index > length
      } else {
        return true
      }
    },
    getCellClassName (item) {
      // 只有这几个控件需要调整  文本框、数字框、流水框、日期
      return ['rc-input', 'rc-numeric', 'rc-flowing-water', 'rc-date'].includes(item.componentType) ? 'update-cell-padding' : ''
    },
    previewOrUploadFile (id, index) {
      this.copyPaste.activeComponent = {id, index}
    },
    controlClick (component, index) {
      this.copyPaste.selectControlIds = []
      this.copyPaste.moveState = false
      this.copyPaste.canMove = true
      this.copyPaste.firstSelectControl = {id: component.id, index}
      this.copyPaste.rightSelectControl = {}
      this.$nextTick(() => this.copyPaste.selectControlIds.push({id: component.id, index}))
    },
    tableMouse (type, flag) {
      if (this.component.properties.disableCopy) return false
      // 如果没有先选中一个，则不能选，否则容易出问题
      if (!this.copyPaste.canMove && !flag) {
        return false
      }
      this.copyPaste.moveState = type === 'down'
      this.copyPaste.canMove = type !== 'up'
      if (type === 'up') {
        this.setRightControls()
      }
    },
    // 鼠标移入的时候触发
    controlMove (component, index) {
      if (this.component.properties.disableCopy) return false
      if (this.copyPaste.selectControlIds.length > 0) {
        // 必须要从选中的那个位置的元素开始拖动
        if (this.copyPaste.selectControlIds.length === 1) {
          if (component.id !== this.copyPaste.firstSelectControl.id && index !== this.copyPaste.firstSelectControl.index) {
            this.copyPaste.selectControlIds = [{...this.copyPaste.firstSelectControl}]
          }
        }
        let i = this.copyPaste.selectControlIds.findIndex(c => c.id === component.id && c.index === index)
        if (i === -1) {
          let result = this.addSelectControls(component.id, index)
          let disposeData = _.cloneDeep(this.copyPaste.selectControlIds)
          result.forEach(r => !disposeData.find(c => c.id === r.id && c.index === r.index) && disposeData.push({...r}))
          this.$set(this.copyPaste, 'selectControlIds', this.disposeControls(disposeData))
        } else {
          // 删除后面选中的元素
          this.$set(this.copyPaste, 'selectControlIds', this.deleteSelectControls(component.id, index))
        }
      } else {
        this.copyPaste.selectControlIds = [{id: component.id, index}]
      }
    },
    // 鼠标回来需要删除选中的控件
    deleteSelectControls (id, index) {
      if (this.component.properties.disableCopy) return false
      // 删除的时候是删除当前列和当前行
      let startIndex = this.copyPaste.selectControlIds[0].index
      let controls = this.getControlIds()
      let firstIndex = controls.indexOf(this.copyPaste.selectControlIds[0].id)
      let endIndex = controls.indexOf(id)
      let result = []
      if (endIndex === firstIndex) {
        if (index > startIndex) {
          return this.copyPaste.selectControlIds.filter(c => c.id === id && c.index <= index)
        } else if (index < startIndex) {
          return this.copyPaste.selectControlIds.filter(c => c.id === id && c.index >= index)
        } else {
          return this.copyPaste.selectControlIds.filter(c => c.id === id && c.index === index)
        }
      }
      if (endIndex > firstIndex) {
        // 右边删除
        controls = controls.filter((c, i) => i > endIndex)
      } else if (endIndex < firstIndex) {
        // 左边删除
        controls = controls.filter((c, i) => i < endIndex)
      }
      if (index < startIndex) {
        result = this.copyPaste.selectControlIds.filter(c => !controls.includes(c.id) && c.index >= index)
      } else if (index > startIndex) {
        result = this.copyPaste.selectControlIds.filter(c => !controls.includes(c.id) && c.index <= index)
      } else {
        result = this.copyPaste.selectControlIds.filter(c => !controls.includes(c.id) && c.index === index)
      }
      return result
    },
    // 选中控件
    addSelectControls (id, index) {
      let controls = this.getControlIds()
      // 首先获取第最小坐标
      let minStartY = Math.min(...this.copyPaste.selectControlIds.map(m => m.index))
      let position = {
        x: controls.indexOf(this.copyPaste.selectControlIds[0].id),
        y: this.copyPaste.selectControlIds[0].index
      }
      // 需要将当前控件和第一个选中的控件之间的控件选中
      let needSelectPosition = {
        x: controls.indexOf(id),
        y: index
      }
      let needSelectControls = []
      controls.forEach((c, i) => {
        if (needSelectPosition.x <= position.x) {
          i >= needSelectPosition.x && i <= position.x && needSelectControls.push({id: c, index: i})
        } else if (needSelectPosition.x >= position.x) {
          i <= needSelectPosition.x && i >= position.x && needSelectControls.push({id: c, index: i})
        }
      })
      let needPushControls = []
      let minY = position.y < needSelectPosition.y ? position.y : needSelectPosition.y
      let maxY = position.y > needSelectPosition.y ? position.y : needSelectPosition.y
      minY = minY < minStartY ? minY : minStartY
      for (let i = minY; i <= maxY; i++) {
        needSelectControls.forEach(c => needPushControls.push({id: c.id, index: i}))
      }
      return needPushControls
    },
    // 禁止拖拽
    domDragstart (e) {
      this.copyPaste.moveState = false
      this.copyPaste.canMove = false
      return false
    },
    tableMouseLeave: _.debounce(function () {
      this.copyPaste.moveState = false
      this.copyPaste.canMove = false
      this.setRightControls()
    }),
    // 因为表格从边边角过来会导致有空缺
    disposeControls (disposeData) {
      let copyData = _.cloneDeep(disposeData)
      // 首先找出第一个选中的坐标
      let position = this.getPosition(disposeData)
      let controls = this.getControlIds()
      for (let x = position.firstPosition.x; x <= position.lastPosition.x; x++) {
        for (let y = position.firstPosition.y; y <= position.lastPosition.y; y++) {
          !copyData.find(c => c.id === controls[x] && c.index === y) && copyData.push({id: controls[x], index: y})
        }
      }
      return copyData
    },
    getControlIds () {
      if (this.copyPaste.controlIds.length) {
        return this.copyPaste.controlIds
      } else {
        let controls = this.component.children.map(m => m.id)
        this.copyPaste.controlIds = controls
        return controls
      }
    },
    getPosition (disposeData = this.copyPaste.selectControlIds) {
      let copyData = _.cloneDeep(disposeData)
      let controls = this.getControlIds()
      let firstChildren = {...this.copyPaste.firstSelectControl}
      let sortData = _.sortBy(_.cloneDeep(disposeData), item => item.index + controls.indexOf(item.id))
      let lastChildren = {...copyData.slice(-1)[0]}
      // 首先找出第一个选中的坐标
      let firstPosition = {
        x: controls.indexOf(firstChildren.id),
        y: firstChildren.index
      }
      let lastPosition = {
        x: controls.indexOf(lastChildren.id),
        y: lastChildren.index
      }
      let minY = 0
      let maxY = 0
      let minX = 0
      let maxX = 0
      // 上下拖动
      if (sortData[0].id === sortData.slice(-1)[0].id) {
        maxX = controls.indexOf(firstChildren.id)
        minX = maxX
        maxY = sortData.slice(-1)[0].index
        minY = sortData[0].index
      } else {
        let sortDataByX = _.sortBy(_.cloneDeep(disposeData), item => controls.indexOf(item.id))
        minX = controls.indexOf(sortDataByX[0].id)
        maxX = controls.indexOf(sortDataByX.slice(-1)[0].id)
        let column = _.cloneDeep(_.cloneDeep(disposeData).filter(c => c.id === firstChildren.id))
        let sortDataByY = _.sortBy(column, item => item.index)
        minY = sortDataByY[0].index
        maxY = sortDataByY.slice(-1)[0].index
      }
      return {firstPosition, lastPosition, minY, maxY, minX, maxX}
    },
    getBorder (item, index, copyData) {
      let className = ''
      if (this.copyPaste.selectControlIds.length === 0) return ''
      if (this.copyPaste.selectControlIds.length === 1) {
        if (item.id === this.copyPaste.selectControlIds[0].id && index === this.copyPaste.selectControlIds[0].index) {
          className += ' first-select-control'
        }
        return className
      } else {
        let controls = this.getControlIds()
        let position = this.getPosition(copyData)
        /*
        * select-control-left
          select-control-right
          select-control-top
          select-control-bottom */
        if (controls.indexOf(item.id) === position.maxX) {
          className += ' select-control-right'
        }
        if (controls.indexOf(item.id) === position.minX) {
          className += ' select-control-left'
        }
        if (index === position.minY) {
          className += ' select-control-top'
        }
        if (index === position.maxY) {
          className += ' select-control-bottom'
        }
      }
      return className
    },
    copyEvent (e) {
      if (this.copyPaste.selectControlIds.length > 1) {
        e.clipboardData.setData('text/plain', this.getDisposeData())
        e.preventDefault()
      }
    },
    pasteEvent (e) {
      // 因为这个方法的原因导致全局mixin文件中设置的无效了
      if (this.component.properties.disablePaste) {
        e.preventDefault()
        return false
      }
      // 表格如果是查看或者流程历史节点或者开启了表格编辑模式不可黏贴
      if (this.copyPaste.selectControlIds.length > 1 && !this.disable && !this.component.properties.enableEdit) {
        let text = ''
        if (window.clipboardData && window.clipboardData.getData) { // IE
          text = window.clipboardData.getData('Text')
        } else {
          text = e.clipboardData.getData('Text')
        }
        if (text) {
          let result = []
          // mac区分
          let columns = navigator.platform.match('Mac') ? text.split(/[\r\n]/) : text.split(/\r\n/)
          columns.forEach(c => result.push(c ? c.split('\t') : ''))
          this.setDisposeData(result)
        }
        e.preventDefault()
      }
    },
    getSortData () {
      // 一开始写的时候没想到用columnId 造孽啊
      let copyControls = _.cloneDeep(this.copyPaste.selectControlIds)
      let controls = this.getControlIds()
      let position = this.getPosition(copyControls)
      // 一行选了个几个控件
      let controlsCount = position.maxX - position.minX + 1
      // 根据行数来排序
      copyControls = _.sortBy(copyControls, item => item.index)
      let sortResult = []
      // 有几列
      let column = copyControls.length / controlsCount
      for (let i = 0; i < column; i++) {
        sortResult.push({
          index: position.minY + i,
          result: _.sortBy(copyControls.slice(i * controlsCount, controlsCount * (i + 1)), item => controls.indexOf(item.id))
        })
      }
      return sortResult
    },
    getDisposeData () {
      let result = []
      let sortResult = this.getSortData()
      sortResult.forEach(c => {
        if (c.result && c.result.length) {
          let data = []
          c.result.forEach(r => {
            let component = this.component.children.find(f => f.id === r.id)
            // 没有开启禁止复制的控件才能复制
            if (component && !component.properties.disableCopy) {
              let value = this.value[c.index][component.archive.columnId]
              if (component.componentType === 'rc-coding') {
                // 流水框将这玩意替换成空
                value = value.replace('prefixe=>', '')
              }
              // 复制需要过滤空值
              value !== '' && data.push(value)
            }
          })
          result.push({
            index: c.index,
            result: data
          })
        }
      })
      let text = ''
      result.forEach(r => {
        text += `${r.result.join('\t')}\r\n`
      })
      return text
    },
    keyupEscEvent (e) {
      this.copyPaste.selectControlIds.length > 0 && e.which === 27 && this.cancelSelect()
      // 可以判断是不是mac，如果是mac,ctrl变为花键
      if (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey && (!this.tableCtrlKey)) {
        this.tableCtrlKey = true
      }
    },
    keyupEvent (e) {
      if (navigator.platform.match('Mac') ? !e.metaKey : !e.ctrlKey && (this.tableCtrlKey)) {
        this.tableCtrlKey = false
      }
    },
    cancelSelect () {
      this.copyPaste.selectControlIds = []
      this.copyPaste.moveState = false
      this.copyPaste.canMove = false
    },
    setDisposeData (data) {
      let sortResult = this.getSortData()
      // 文本框、数字框、流水框、日期 可修改
      let filterComponentTypes = ['rc-input', 'rc-numeric', 'rc-flowing-water', 'rc-date']
      // 过滤所选的内容中，非可修改控件
      let disposeResult = []
      sortResult.forEach(c => {
        let columnIds = []
        c.result && c.result.length && c.result.forEach(r => {
          let component = this.component.children.find(children => children.id === r.id)
          if (component && !component.properties.readonly && filterComponentTypes.includes(component.componentType)) {
            columnIds.push(component.archive.columnId)
          }
        })
        disposeResult.push({
          index: c.index,
          result: columnIds
        })
      })
      this.setTableValue(disposeResult, data)
    },
    // selectResult：表格选中的控件
    // data: excel选中的数据
    async setTableValue (selectResult, data) {
      // 如果表格选中的行数比从excel选中的行数要少
      if (selectResult.length <= data.length) {
        await this.extensionData(selectResult, data).then(res => { selectResult = res })
      }
      // 文本框、数字框、流水框、日期 可修改
      let filterComponentTypes = ['rc-input', 'rc-numeric', 'rc-flowing-water', 'rc-date']
      selectResult && selectResult.length && selectResult.forEach((d, i) => {
        d.result && d.result.length && d.result.forEach((r, j) => {
          if (data[i] && j <= data[i].length - 1) {
            let component = this.component.children.find(c => c.archive.columnId === r)
            if (component) {
              // 只有在控件隐藏的时候这个值才不会返回
              let disposeComponent = this.getItem(component, this.value[d.index].id)
              // 非 禁用、只读、禁止粘贴 的控件可以粘贴值
              if (disposeComponent && filterComponentTypes.includes(component.componentType) && !disposeComponent.properties.readonly && !disposeComponent.properties.hidden && !disposeComponent.properties.disablePaste) {
                this.$set(this.value[d.index], r, data[i][j].trim())
              }
            }
          }
        })
      })
    },
    // 如果表格行数不够，则向下延伸
    async extensionData (selectResult, data) {
      let copySelectResult = _.cloneDeep(selectResult)
      let sortResult = this.getSortData()
      // 获取表格选中的最后一行的索引
      let lasLine = copySelectResult.slice(-1)[0].index
      // 可以添加的行
      let canAddLine = this.value.length - 1 - lasLine
      // 相差行数
      let differLine = data.length - copySelectResult.length
      if (differLine <= canAddLine) {
        // 一行的控件id
        let componentIds = sortResult[0].result.map(c => c.id)
        let columnIds = copySelectResult[0].result
        canAddLine = differLine > canAddLine ? canAddLine : differLine
        canAddLine = canAddLine + lasLine
        for (let i = lasLine; i < canAddLine; i++) {
          let result = []
          componentIds.forEach((c, j) => {
            result.push({id: columnIds[j], index: i + 1})
            this.copyPaste.selectControlIds.push({id: c, index: i + 1})
          })
          copySelectResult.push({index: i + 1, result: result.map(c => c.id)})
          this.$nextTick(() => this.setRightControls())
        }
      } else {
        // 需要给表格添加的行。
        let needAddLine = differLine - canAddLine
        for (let i = 0; i < needAddLine; i++) {
          await this.addRow(true)
        }
        this.$nextTick(() => {
          this.scrollDown()
          // 重新向下延展
          this.setDisposeData(data)
        })
      }
      return Promise.resolve(copySelectResult)
    },
    setRightControls () {
      if (this.copyPaste.selectControlIds.length > 1) {
        // 给最后一个位置的元素加上 拖拽？
        let position = this.getPosition(this.copyPaste.selectControlIds)
        let rightSelectControl = {
          id: this.getControlIds()[position.maxX],
          index: position.maxY,
          position: 'right'
        }
        if (rightSelectControl.id === this.copyPaste.firstSelectControl.id) {
          rightSelectControl = {
            id: this.getControlIds()[position.minX],
            index: position.maxY,
            position: 'left'
          }
        }
        this.copyPaste.rightSelectControl = rightSelectControl
      } else {
        this.copyPaste.rightSelectControl = {}
      }
    },
    async updateDataSource (data) {
      // 修改当前点击的数据源控件下面的控件的值
      let maxIndex = data.values.length + data.index + 1
      let component = data.component
      // 判断是否需要增加行。
      if (this.value.length < maxIndex) {
        let needAddRow = maxIndex - this.value.length
        for (let i = 0; i < needAddRow; i++) {
          await this.addRow(true)
          this.scrollDown()
        }
      }
      this.$nextTick(async () => {
        let index = -1
        for (; data.index < maxIndex; data.index++) {
          let item = data.values[++index]
          if (item) {
            let value = item[component.properties.dataSourceData.showColumnId]
            await this.updateChildValue(data.columnId, value, data.index + 1)
            component.properties.dataSourceData.dataBinding && component.properties.dataSourceData.dataBinding.forEach(m => {
              // 这个地方使用的应该归档ID, 但是命名的时候使用了 componentId
              this.updateChildValue(m.componentId, item[m.showColumnId], data.index + 1)
            })
          }
        }
      })
    },
    dbClick (scope) {
      if (this.component && this.component.properties && this.component.properties.enableEdit) {
        this.editRow(scope)
      }
    },
    // 加载默认辅助表数据
    async initDefaultDataSource () {
      if (this.component.properties.tableDataSource && this.component.properties.tableDataSource.defaultData && this.component.properties.tableDataSource.dataSource) {
        let filters = _.cloneDeep(this.component.properties.tableDataSource.filter)
        if (filters && Object.keys(filters).length) {
          Object.keys(filters).forEach(m => {
            if (filters[m].match(/\$\{(.*?)\}/)) {
              let expression = {
                'expression': _.clone(filters[m]),
                'path': this.getCurrentPath(),
                'callback': (data) => {
                  filters[m] = data
                  return this.search(filters)
                }
              }
              this.getCalculationValue(expression)
            } else {
              return this.search(filters)
            }
          })
        } else {
          return this.search(filters)
        }
      }
    },
    async search (filters) {
      await this.$axios.get(`/report-api/report/data/${this.component.properties.tableDataSource.dataSource}`, {params: {'index': 1, 'size': 1000, filters}}).then(res => {
        this.defaultTableData = res.data
      })
    },
    // 给表格中的控件设置辅助表的值
    setValueWithDataSource (index) {
      // 辅助表数据不够就不执行赋值操作了
      if (this.defaultTableData[index]) {
        let dataBinding = this.component.properties.tableDataSource.dataBinding
        dataBinding && dataBinding.length && dataBinding.forEach(d => {
          // componentId：控件
          // showColumnId：字段
          if (d.componentId && d.showColumnId) {
            this.$set(this.value[index], d.componentId, this.defaultTableData[index][d.showColumnId])
          }
        })
      }
    },
    // 是否渲染列
    renderColumn (item) {
      return Object.keys(this.columnsProperties).find(key => {
        let columnProperties = this.columnsProperties[key].find(e => e.id === item.id)
        // 如果列被设置了隐藏 但是列子控件存在控件交互属性 且 子控件交互属性为不隐藏时 渲染该列(未区分占位与不占为,在表格内无意义)
        if (item.properties.hidden && columnProperties && !columnProperties.properties.hidden) {
          return true
        }
      })
    },
    // 是否加载表格内组件
    getItem (item, rowId) {
      item = this.$_.cloneDeep(item)
      if (this.columnsProperties[rowId]) {
        let findColumn = this.columnsProperties[rowId].find(c => c.id === item.id)
        item.properties = findColumn ? this.$_.cloneDeep(findColumn.properties) : item.properties
      }
      if (item.properties && item.properties.hidden) {
        return false
      } else {
        return item
      }
    },
    updateCheck (state, row) {
      if (!state) {
        let index = this.checkLine.selectRows.findIndex(r => r.id === row.id)
        index !== -1 && this.checkLine.selectRows.splice(index, 1)
      } else {
        this.checkLine.selectRows.push(row)
      }
      this.checkLine.isIndeterminate = this.checkLine.selectRows.length !== this.rows.length
      this.checkLine.checkAll = this.checkLine.selectRows.length === this.rows.length
      this.eventBus.$emit('form.table-select-change', {rows: this.checkLine.selectRows, component: this.component})
    },
    handleCheckAllChange (val) {
      if (val) {
        this.checkLine.selectRows = this.$_.cloneDeep(this.rows)
      } else {
        this.checkLine.selectRows = []
      }
      this.checkLine.checkAll = val
      this.checkLine.isIndeterminate = false
      this.eventBus.$emit('form.table-select-change', {rows: this.checkLine.selectRows, component: this.component})
    }
  },
  computed: {
    componentChildren () {
      return this.component.children.filter(e => {
        return !e.properties.hidden || (e.properties.hidden && this.renderColumn(e))
      })
    },
    hiddenColumns () {
      return this.$_.difference(this.component.children, this.componentChildren)
    },
    rows () {
      return this.value && this.value.filter(m => m.dataState !== 'delete')
    },
    height () {
      let result = '78px'
      if (this.value) {
        if (this.value.length) {
          result = 36 + 42 * this.value.length + 11 + 'px'
        }
      }
      return result
    },
    getTooltipStyle () {
      return (item) => {
        if (this.columnWidth(item) < this.getTextWidth(item.name, 14)) {
          return {
            'position': 'relative',
            'top': '-6px'
          }
        } else {
          return {}
        }
      }
    },
    getRequired () {
      return (item) => {
        item = _.cloneDeep(item)
        // 因为目前只是改 required 属性，如果这个有值，则代表改列需要显示必填
        if (Object.keys(this.requiredList).length > 0) {
          let arr = this.requiredList.filter(r => r.id === item.id)
          if (arr && arr.length > 0) {
            let properties = arr.find(a => a.required)
            return !!properties
          } else {
            return item.properties.required
          }
        } else {
          return item.properties.required
        }
      }
    },
    getActiveControl () {
      return (item, index) => {
        let className = ''
        className += item.id === this.copyPaste.activeComponent.id && index === this.copyPaste.activeComponent.index ? ' active-rc-file' : ''
        if (this.copyPaste.selectControlIds.length === 0) return className
        let copyData = _.cloneDeep(this.copyPaste.selectControlIds)
        // 首先找出第一个选中的坐标
        let position = this.getPosition(copyData)
        let firstLine = _.sortBy(copyData.filter(f => f.id === this.copyPaste.firstSelectControl.id), item => item.index)
        let lastLine = _.sortBy(copyData.filter(f => f.id === position.lastPosition.id))
        if (firstLine.length !== lastLine.length) {
          if (lastLine.length !== 0) {
            let index = firstLine.slice(-1)[0].index
            copyData.push({id: lastLine[0].id, index})
          }
        }
        let c = copyData.find(c => c.id === item.id && c.index === index)
        className += c ? ' select-control' : ''
        className += c ? this.getBorder(item, index, copyData) : ''
        return className
      }
    },
    getComponentClass () {
      return (item, index) => {
        let className = 'component-content'
        if (this.copyPaste.selectControlIds.length < 1) return className
        if (item.id === this.copyPaste.rightSelectControl.id && index === this.copyPaste.rightSelectControl.index && this.copyPaste.selectControlIds.length > 1) {
          className += this.copyPaste.rightSelectControl.position === 'left' ? ' resize-control-left' : ' resize-control'
        }
        if (this.copyPaste.selectControlIds.length > 1) {
          className += ' none-select'
        }
        return className
      }
    },
    getSelect () {
      return row => !!this.checkLine.selectRows.find(n => n.id === row.id)
    },
    readonly () {
      return this.component.properties.readonly
    },
    getTextWidth () {
      return (text, fontsize) => {
        const newSpan = document.createElement('span')
        newSpan.style.fontSize = fontsize
        newSpan.style.visibility = 'hidden'
        newSpan.innerText = text
        document.body.appendChild(newSpan)
        const width = newSpan.offsetWidth
        newSpan.parentNode.removeChild(newSpan)
        return width
      }
    },
    // 获取列宽，如果未设置则为 140
    columnWidth () {
      return component => {
        // 处理历史数据
        const widths = this.component.properties.widths
        if (widths && widths.length) {
          const width = this.component.properties.widths.find(f => f.columnId === component.archive.columnId)
          return width ? width.columnWidth : 140
        } else {
          const columnWidth = component.properties.columnWidth
          return isNaN(columnWidth) ? 140 : Number(columnWidth)
        }
      }
    }
  },
  mounted () {
    if (this.isFixed === null && this.$refs[this.component.id]) {
      this.isFixed = this.compareWidth() ? 'right' : false
    }
    this.isFirefox = window.navigator.userAgent.indexOf('Firefox') > -1
    // 表单emit出来的方法，在表单校验之前触发，如果控件必填，加上提必填样式
    this.eventBus.$on('form.afterValidate', () => this.validateRcFile())
    document.addEventListener('copy', this.copyEvent)
    document.addEventListener('paste', this.pasteEvent)
    document.addEventListener('keydown', this.keyupEscEvent)
    document.addEventListener('keyup', this.keyupEvent)
  },
  updated () {
    // 表格新增隐藏列渲染时手动重新渲染整个表格
    this.$refs[this.component.id] && this.$refs[this.component.id].doLayout()
  },
  watch: {
    dialogVisible (val) {
      !val && this.selectScope.$index === this.rows.length - 1 && this.scrollDown()
    },
    'dataService.data' (val) {
      this.initDefaultDataSource()
    },
    'defaultTableData' () {
      this.initComponent()
    }
  },
  async created () {
    this.columns = this.getColumns()
    // await this.initDefaultDataSource()
    // 为了保证每个表格的redcatEventBus不相同 如果开启了表单编辑且不是默认表单，就需要告诉父组件创建一个新的redcatEventBus实例
    if (this.component && this.component.properties && this.component.properties.selectForm !== '[默认表单]' && this._redcatEventBus) {
      let currentTableFormListener = this._redcatEventBus.formRuntimeListenerArray.find(item => item.id === this.parentFormId)
      currentTableFormListener.redcatEventBus.$emit('tableEditCreate', this.component.id)
      this.$nextTick(() => {
        let currentTableListener = this._redcatEventBus.rcTableListenerArray.find(item => item.id === this.component.id)
        if (currentTableListener.redcatEventBus) {
          let tableRedcatEventBus = currentTableListener.redcatEventBus
          tableRedcatEventBus.$on('tableEditSubmit', this.getFormData)
          // 开启表单编辑，取消（未保存）的时候删除掉新增的那条数据
          tableRedcatEventBus.$on('tableEditCancel', () => {
            // 需要过滤已删除数据
            if (this.value && this.value.filter(f => f.dataState !== 'delete').length > this.rows.filter(m => m.isSave !== 0).length) {
              this.value.pop()
            }
          })
        }
      })
    }
  },
  beforeDestroy () {
    document.removeEventListener('copy', this.copyEvent)
    document.removeEventListener('paste', this.pasteEvent)
    document.removeEventListener('keydown', this.keyupEscEvent)
    document.removeEventListener('keyup', this.keyupEvent)
    // 退出时将表格所属事件从实例数组中剔除，同时销毁掉所有相应事件
    let needDestroyTableEventBusIndex = this._redcatEventBus.rcTableListenerArray.findIndex(item => item.id === this.component.id)
    if (needDestroyTableEventBusIndex !== -1) {
      let needDestroyTableEventBus = this._redcatEventBus.rcTableListenerArray.splice(needDestroyTableEventBusIndex, 1)
      needDestroyTableEventBus[0].redcatEventBus.$off()
    }
  }
}
</script>

<style lang="scss">
.rc-table-run {
  position: relative;
  height: calc(100% - 20px);
  .el-table__body-wrapper{
    .el-form-item__label{
      display: none;
    }
    .el-table__body{
      margin-bottom: 6px;
      .el-checkbox:last-of-type {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
      }
    }
    .el-table__row {
     .cell .component-content .el-form-item .el-form-item__content .component-explain-tooltip {
       display: none;
      }
      .operation-class {
        background-color: #fff;
      }
      &:hover {
        td {
          background-color: #fff;
        }
        .operation-class {
          background-color: #fff;
        }
      }
      .is-error {
        .el-form-item__content {
          .is-disabled {
            .el-input__inner {
              border-color: #F56C6C;
            }
          }
        }
      }
    }
  }
  .el-table {
    th {
      >.cell {
        color: #181818;
      }
    }
    .el-table__fixed-right {
      background-color: #fff;
      .el-table__fixed-body-wrapper {
        .el-table__body {
          .el-table__row {
            .operation-class {
              background-color: #fff;
            }
            &:hover {
              .operation-class {
                background-color: #fff;
              }
            }
          }
        }
      }
    }
  }
  .rc-table-header{
    position: relative;
    height: 30px;
    line-height: 30px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border: 1px solid #c2c3c4;
    background: rgb(245,245,245);
    border-bottom: none;
    padding-left: 10px;
    .component-explain-tooltip {
      color: #c0c2c1;
      cursor: pointer;
      &:hover {
        color: #3a8ee6
      }
    }
    .rc-table-runtime-tip {
      position: absolute;
      top: 0;
      right: 13px;
      cursor: pointer;
      &:hover {
        color: #3a8ee6
      }
      &:hover:after {
        content: '按ctrl键同时，选中表格区域，可复制/粘贴数据内容。';
        position: absolute;
        left: -120px;
        top: 35px;
        border-radius: 4px;
        padding: 10px;
        z-index: 2000;
        font-size: 12px;
        line-height: 1.2;
        min-width: 10px;
        background: #303133;
        color: #fff;
        transform: translateX(-50%);
        white-space: nowrap;
      }
      &:hover:before {
        content: '';
        position: absolute;
        left: 70%;
        top: 29px;
        z-index: 2000;
        border-bottom:6px solid #303133;
        border-left:6px solid transparent;
        border-right:6px solid transparent;
        margin-left: -9px;
      }
    }
    .icons {
        position: absolute;
        right: 10px;
        top: 0px;
        cursor: pointer;
        color:#C2C3C4;
      }
    .add-row:hover {
      color: var(--light-5, #8ECAF9);
    }
  }
  .rc-table-footer {
    text-align: center;
    padding: 17px 0 16px 0;
    border: 1px solid #c2c3c4;
    border-top: 0;
    .el-icon-plus {
      font-size: 13px;
      font-weight: 800;
    }
    .rc-add-button {
      width: 50px;
      margin: 0 auto;
      .el-icon-plus, .add-button {
        color: var(--light-5, #8ECAF9);
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }
      &:active {
        .el-icon-plus {
          color: var(--shade-1, #2480CA);
        }
        .add-button {
          color: var(--shade-1, #2480CA);
        }
      }
    }
  }
  .requrired{
    height: 23px;
    .rc-table-run-label {
      position: relative;
      &::before {
        content:'*';
        position: absolute;
        right: -6px;
        top: -6px;
        color:red;
      }
    }
    .rc-table-run-label-overflow {
      display: inline-block;
      position: relative;
      width: calc(100% - 50px);
      &::before {
        content: '*';
        position: absolute;
        right: 1px;
        top: -6px;
        color: red;
      }
    }
  }
  .el-table__fixed-right::before, .el-table__fixed::before {
    display: none;
  }
  .el-table__fixed, .el-table__fixed-right {
    box-shadow: none;
    bottom: 10px!important;
  }
  /* 修改 通过style 加上的样式 */
  .el-table--scrollable-y {
    .el-table__fixed-right {
      right: 8px!important;
    }
  }
  .firefox-scrollbar {
    .el-table__fixed-right {
      bottom: 17px!important;
    }
  }
  .tableClass {
    .component-explain-tooltip {
      color: #c0c2c1;
      cursor: pointer;
      &:hover {
        color: #3a8ee6
      }
    }
  }
  .tableClass .el-table__header-wrapper {
    border-bottom: 0;
    .el-table__header {
      .has-gutter {
        tr {
          th {
            border-bottom: 1px solid #EBEEF5;
            .cell {
              height: 23px;
              .rc-table-run-label {
                height: 23px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
              .rc-table-run-label-overflow {
                width: calc(100% - 50px);
                position: relative;
                display: inline-block;
                height: 23px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
            }
          }
          .operation-class {
            border-bottom: none;
          }
        }
      }
    }
  }
  .operation-class {
    border: none;
  }
  .el-icon-circle-close {
    color: #B0B0B2;
    font-size: 16px;
    cursor: pointer;
    &:active {
      color: #EE5451;
    }
  }
  .icon-item {
    color: #C2C3C4;
    cursor: pointer;
    display: none;
  }

  .tableClass {
    width: 100%;
    font-size: 12px;
    border: 1px solid #c2c3c4;
    border-bottom: 0;
    .el-table__row{
      &:hover {
        .operation-class {
          background-color: #fff;
        }
        .icon-item {
          display: inline-block;
        }
      }
    }
    .hover-row {
      td {
        background-color: #fff;
      }
      .icon-item {
        display: inline-block;
      }
    }
    .selected {
      &:hover {
        td {
          background-color: #ecf5ff;
        }
      }
      .icon-item {
        display: inline-block;
      }
    }
    .icon-container {
      span {
        font-size: 14px;
        user-select: none;
      }
      &:hover {
        .el-icon-circle-close {
          display: inline-block;
          color: #FA8886;
        }
        .el-icon-edit {
          color: var(--light-5, #8ECAF9);
          user-select: none;
        }
      }
      .el-icon-edit {
        margin-right: 3px;
        &:active {
          color: var(--shade-1, #388DD2);
        }
      }
      .el-icon-circle-close {
        &:active {
          &::before{
            content: '\e79d';
          }
          color: #EE4A3E;
        }
      }
    }
    .el-table__header th.is-leaf {
      border-bottom: none;
    }
    .has-gutter tr{
      th .cell{
        padding: 0;
      }
    }
    .cell-padding{
      padding: 0;
      height: 1px;
      .cell{
        padding: 0;
        .component-content {
          height: 40px;
          width: 100%;
          position: relative;
          .resize-icon {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 5px;
            height: 5px;
            background-color: #409EFF;
            cursor: cell;
            display: none;
          }
          * {
            user-select: inherit;
          }
          .el-form-item {
            .el-form-item__content {
              height: 40px;
            }
          }
        }
        .none-select {
          * {
            user-select: none;
          }
        }
        .resize-control {
          .resize-icon {
            display: inline-block;
          }
        }
        .resize-control-left {
          .resize-icon {
            display: inline-block;
            right: calc(100% - 5px);
          }
        }
        .rc-data-source-runtime{
          height: 40px;
          .el-row{
            div:first-of-type{
              display: none;
            }
          }
          .el-form-item {
            height: 100%;
          }
        }
        .rc-currency-run {
          height: 100%;
          .el-form-item__content {
            height: 100%;
          }
        }
        .el-form-item.rc-input-run.el-form-item--mini,.el-form-item.date-form-item.el-form-item--mini{
          width: 100%;
        }
        .el-form-item {
          .el-form-item__content{
            border: 1px solid transparent;
          }
        }
        .el-form-item:not(.button-run) {
          .el-form-item__content{
            width: 100%;
            .el-date-editor.el-input{
              .el-input__inner{
                padding-right: 20px;
              }
              .el-input__suffix{
                right: 1px;
              }
            }
          }
        }
        .active-rc-file {
          .el-form-item__content {
            .rc-file-runtime {
              border: 1px solid var(--shade-1, #2F96E7);
            }
          }
        }
        .select-control {
          .el-form-item__content {
            border: 1px solid transparent;
          }
        }
        .el-form-item {
          margin-left: 0;
          .el-form-item__content {
            // 修改style属性
            margin-left: 0 !important;
            padding: 5px 6%;
          }
        }
        .select-control-left {
          .el-form-item__content {
            border-left-color: var(--primary, #409EFF);
          }
        }
        .select-control-right {
          .el-form-item__content {
            border-right-color: var(--primary, #409EFF);
          }
        }
        .select-control-top {
          .el-form-item__content {
            border-top-color: var(--primary, #409EFF);
          }
        }
        .select-control-bottom {
          .el-form-item__content {
            border-bottom-color: var(--primary, #409EFF);
          }
        }
        .first-select-control {
          .el-form-item__content {
            border-color: var(--shade-1, #2F96E7);
          }
        }
      }
    }
    .operation-class {
      .cell {
        height: auto;
      }
    }
    .el-table__body-wrapper {
      .update-cell-padding {
        padding: 0;
        // 不知道为什么设置了padding为0 还是显示有padding。随便加个小于42大与0的高度就会使得高度填充满
        height: 30px;
        .cell {
          padding: 0;
          height: 100%;
          .rc-input-run, .el-numeric-run, .rc-flowing-water-run, .rc-date-run {
            height: 100%;
            margin-left: 0;
            border: 1px solid transparent;
            .el-form-item__content {
              // 修改style属性
              margin-left: 0 !important;
              // 层级不够了
              width: 100% !important;
              padding: 0;
              border: none;
              height: 100%;
              .el-input {
                height: 100%;
                width: 100%;
                .el-input__inner {
                  height: 100%;
                  width: 100%;
                  border-color: transparent;
                  border-radius: 0;
                  &:focus {
                    border-color: var(--primary, #409EFF);
                  }
                }
              }
            }
          }
          .rc-flowing-water-run {
            .el-form-item__content {
              .el-input {
                .el-input__inner {
                  background: #fff;
                }
              }
            }
          }
          .select-control {
            border: 1px solid transparent;
          }
          .select-control-left {
            border-left-color: var(--primary, #409EFF);
          }
          .select-control-right {
            border-right-color: var(--primary, #409EFF);
          }
          .select-control-top {
            border-top-color: var(--primary, #409EFF);
          }
          .select-control-bottom {
            border-bottom-color: var(--primary, #409EFF);
          }
          .first-select-control {
            border-color: var(--shade-1, #2F96E7);
            .el-form-item__content {
              .el-input {
                .el-input__inner {
                  border-color: transparent;
                  &:focus {
                    border-color: transparent;
                  }
                }
              }
            }
          }
        }
      }
    }
   .rc-table-index {
      .cell {
        & > div {
          vertical-align: middle;
          height: 100%;
          line-height: 40px;
        }
      }
    }
    .rc-table-check {
      .cell {
        & > div {
          vertical-align: middle;
          height: 100%;
          line-height: 40px;
        }
      }
    }
    tr.selected {
      background: #EBF6FF;
    }

    .el-form-item--mini.el-form-item,
    .el-form-item--small.el-form-item {
      width: 100%;
      margin-left: -90px;
      margin-bottom: 0;
    }
    .el-form-item--mini.el-form-item.button-run,
    .el-form-item--small.el-form-item.button-run{
      margin-left: 0;
    }
  }
  .el-disable {
    .el-table__body-wrapper .el-table__body tr.current-row>td {
      background-color: #fff;
      &:hover {
        background-color: #fff;
      }
    }
    .el-table__body-wrapper .el-table__body tr td {
      background-color: #fff;
      &:hover {
        background-color: #fff;
      }
    }
  }

  .component-title {
    font-size: 14px;
    font-weight: 100;
  }
  i.component-title {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-table.vue